import $ from 'jquery';

const keyIdentity = '68a4b73a-9f75-4911-ac9e-91f2fc952b99';
const scriptUrl = 'https://identity.b2egroup.com.br/Identity/v1.7.1/b2e.identity.min.js';

const Identity = {
  capturar: function(sessionId, domain) {
    if (window.capturar) {
      window.capturar({
        sid: sessionId,
        key: keyIdentity,
        domain: global.env.ANTI_FRAUD_APP_DOMAIN + '_INTERLINE_' + domain
      });
    } else {
      try {
        $.getScript(scriptUrl).then(function() {
          window.capturar({
            sid: sessionId,
            key: keyIdentity,
            domain: global.env.ANTI_FRAUD_APP_DOMAIN + '_INTERLINE_' + domain
          });
        });
      } catch (err) {
        console.log('Error Identity script: ' + err);
      }
    }
  },
  observarColagem: function(sessionId, domain, ...elementsId) {
    if (window.observarColagem) {
      window.observarColagem({
        sid: sessionId,
        key: keyIdentity,
        domain: global.env.ANTI_FRAUD_APP_DOMAIN + '_INTERLINE_' + domain + '_COPIA_COLA',
        elements: elementsId
      });
    }
  }
};

export default Identity;



// WEBPACK FOOTER //
// ./src/components/modules/identity/index.js